import React, { useEffect } from "react";
import Component1 from "./Component1";
import Component2 from "./Component2";
import Component4 from "./Component4";
import Component41 from "./Component41";
import Component5 from "./Component5";
import Navbar from "../Navbar";

const Components = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <div>
      <Navbar />
      <Component1 />
      <Component2 />
      <Component4 />
      <Component41 />
      <Component5 />
    </div>
  );
};

export default Components;
